import {
  IGetEligibleCandidatesApiResponse,
  IGetEligibleCandidatesResult,
} from '../types';

const toGetEligibleCandidatesResult = (
  response: IGetEligibleCandidatesApiResponse,
): IGetEligibleCandidatesResult => ({
  data: response.data.map((it) => ({
    id: it.id,
    firstName: it.firstName,
    lastName: it.lastName,
    fullName: it.fullName,
    profileImage: it.profileImage,
    profession: it.profession,
    subProfession: it.subProfession,
    yearsOfExperience: it.yearsOfExperience,
    appliedAt: it.appliedAt,
    overallProfessionalRating: it.overallProfessionalRating,
    education: it.education,
    hasMarkedAvailable: it.hasMarkedAvailable ?? false,
    invitedInterviewIds: it.invitedInterviewIds ?? [],
    badges: it.badges ?? [],
  })),
});

export const EligibleCandidateAdapters = {
  toGetEligibleCandidatesResult,
};
